import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RespiratorDetailsComponent } from "./respirator-details/respirator-details.component";
import { RespiratorsComponent } from "./respirators.component";

const routes: Routes = [
    {
      path: '',
      data: {
        title: 'Respirator Inserts'
      },
      children: [
        {
          path: '',
          component: RespiratorsComponent,
          data: {
            title: 'Home'
          }
        },
        {
          path: ':style',
          children: [
            {
              path: '',
              component: RespiratorDetailsComponent,
              data: { title: 'Eyewear Builder'}
            }          
          ]
        }
      ]
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class RespiratorsRoutingModule { }